import Model, { encoders, ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/Model'
import MarketingSubscription from 'src/models/subscription/MarketingSubscription'

export default class Broadcast extends Model {
  static name = 'Broadcast'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      customerioBroadcastId: {
        type: Integer,
        required: true
      },
      customerioSegmentId: {
        type: Integer,
        required: true
      },
      marketingSubscription: {
        type: MarketingSubscription,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      isConfigured: {
        type: Boolean,
        output: true
      },
      dataType: {
        type: String,
        options: ['showtimes', 'last_chance', 'premieres', 'custom'],
        default: null
      },
      dataVariables: {
        type: JsonObject,
        mergeDefault: true,
        default () {
          return {
            relativeStartDay: 1,
            relativeEndDay: 6,
            customData: {}
          }
        }
      },
      channelEmail: {
        type: Boolean,
        default: true
      },
      channelPush: {
        type: Boolean,
        default: false
      },
      channelSms: {
        type: Boolean,
        default: false
      },

      viewBroadcastUrl: {
        type: String,
        output: true
      },

      action: {
        type: String,
        default: null,
        input: true
      },

      actionLanguage: {
        type: String,
        input: true,
        default: null
      }
    }
  }

  async triggerBroadcast (live = false, actionLanguage = null) {
    this.action = live ? 'trigger_broadcast' : 'trigger_broadcast_test'
    if (actionLanguage && !live) {
      this.actionLanguage = actionLanguage
    } else {
      this.actionLanguage = null
    }

    let result
    try {
      result = await this.save()
      if (result.errors.length) {
        console.log(result.errors)
        this.$mh.showErrors(result.errors)
      }
    } catch (error) {
      console.log(error)
      return false
    } finally {
      this.resetField('action')
    }

    return result.errors.length === 0
  }
}
